import * as PrioritizationIndicesActions from './prioritizationIndices';
import * as LogisticIndicesActions from './logisticIndices';

const Actions = {
  ...PrioritizationIndicesActions,
  ...LogisticIndicesActions,
};

export default Actions;
